import api from "utils/api";

export const changeOrg = async (
  id: number | string | undefined,
  refetchOnOrgChange: boolean = true,
  updateOrgReduxState: () => void,
) => {
  if (id === undefined) {
    return;
  }

  await api.put("/api/manage/userprofile/", {
    org: id,
  });

  if (refetchOnOrgChange) {
    updateOrgReduxState();
  }

  return;
};
